<payment-summary-header
  [customerPayment]="customerPayment"
  [hasMultipleTransactions]="hasMultipleTransactions"
  [transactionBuyerAccounts]="transactionBuyerAccounts"
  [transactionsTotal]="transactionsTotal"
  [transactionsSubTotal]="transactionsSubTotal"
  [transactionsCreditTotal]="transactionsCreditTotal"
  [transactionsAppliedDiscountTotal]="transactionsAppliedDiscountTotal"
  [isDiscountAmountVisible]="isDiscountAmountVisible"
  [transactionsSurchargeTotal]="transactionsSurchargeTotal"
  [surchargePercentage]="surchargePercentage"
  [isAutopaySupported]="isAutopaySupported"
  [isAutopayEnabled]="isAutopayEnabled"
  [isSurchargeFeeVisible]="isSurchargeFeeVisible"
  [isSurchargeFeePercentageVisible]="isSurchargeFeePercentageVisible"
  [showAutopayEnrollmentBanner]="showAutopayEnrollmentBanner"
  [autopayBannerVariant]="autopayBannerVariant"
  (enrollInAutopayClicked)="enrollInAutopayClicked.emit()"
>
</payment-summary-header>
<payment-tabbed-transaction-document-table
  [hasMultipleTransactions]="hasMultipleTransactions"
  [modifiedDocuments]="modifiedDocuments"
  [isSurchargeFeeVisible]="isSurchargeFeeVisible"
  [transactions]="transactions"
  [excludedTransactionTableCols]="excludedTransactionTableCols"
  [excludedDocumentTableCols]="excludedDocumentTableCols"
  [showModifiedDocuments]="false"
>
</payment-tabbed-transaction-document-table>
<payment-summary-print
  id="printable"
  [customerPayment]="customerPayment"
  [tenantDetails]="tenantDetails"
  [documents]="modifiedDocuments"
  [transactions]="transactions"
  [hasMultipleTransactions]="hasMultipleTransactions"
  [transactionBuyerAccounts]="transactionBuyerAccounts"
  [transactionsTotal]="transactionsTotal"
  [transactionsSubTotal]="transactionsSubTotal"
  [transactionsCreditTotal]="transactionsCreditTotal"
  [transactionsAppliedDiscountTotal]="transactionsAppliedDiscountTotal"
  [isDiscountAmountVisible]="isDiscountAmountVisible"
  [transactionsSurchargeTotal]="transactionsSurchargeTotal"
  [isSurchargeFeeVisible]="isSurchargeFeeVisible"
>
</payment-summary-print>
